import { trackV2 } from 'utils/analytics';

const LANDING_PAGE = 'landing_page';
const PRIVATE_ACTIVITY = 'private_activity';
const MOBILE_REGISTRATION_PAGE = 'mobile_registration';
const REGISTRATION_PAGE = 'registration';

const pageAttrForAnalytics = (page) => {
  switch (page) {
    case LANDING_PAGE:
      return 'home';
    case PRIVATE_ACTIVITY:
      return 'referral';
    case MOBILE_REGISTRATION_PAGE:
      return 'register_mobile';
    case REGISTRATION_PAGE:
      return 'register';
    default:
      return '';
  }
};

const trackV2Onboarding = (attrs) => {
  trackV2({
    category: 'onboarding',
    ...attrs,
    properties: {
      cohort: 'variant-a', // onboarding experiment current has one variant. This should be removed once the experiment is completed.
      ...attrs.properties
    }
  });
};

export {
  LANDING_PAGE,
  PRIVATE_ACTIVITY,
  MOBILE_REGISTRATION_PAGE,
  REGISTRATION_PAGE,
  pageAttrForAnalytics,
  trackV2Onboarding
};
